export default __webpack_public_path__ + "locales/az/DeleteDialog.json?hash=2353347340f22ad7ac3a6acde2a4b079";